module.exports = __webpack_public_path__ + "./images/6b2b9ef367ca3f3a7fd795e875f9ec83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/cx-logo-new.png
// module id = 1468
// module chunks = 0